import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
    const { auth_token } = useSelector((state) => state.auth);
  return auth_token ? children : <Navigate to="/login" />;
};

export default PrivateRoute;